/**
 * v-reveal — adds the `in` class once the element scrolls into view, which plays
 * the CSS fade/slide transition on `.reveal` / `.stagger` elements.
 *
 * A single shared IntersectionObserver handles every bound element; each one is
 * unobserved after it reveals, so the animation plays only once.
 */
const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        return;
      }
      entry.target.classList.add('in');
      observer.unobserve(entry.target);
    });
  },
  { threshold: 0, rootMargin: '0px 0px -8% 0px' }
);

export default {
  inserted(el) {
    observer.observe(el);
  },
  unbind(el) {
    observer.unobserve(el);
  },
};
